import styled from 'styled-components';
import { rem } from 'polished';
import theme from '../../styles/theme';

const UlListWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .row-wrapper {
    display: flex;
    flex-direction: row;
    align-items: normal;
    margin: 0 0 24px 0;

    .button-check {
      cursor: pointer;
      outline: none;
      border: none;
      background: none;
      height: ${rem('28px')};
      width: ${rem('28px')};
      padding: 0;
      margin: ${`${rem('4px')} ${rem('10px')} 0 0`};

      svg {
        height: ${rem('28px')};
        width: ${rem('28px')};
      }
    }
    .text-content {
      font-size: ${theme.font.paragraph.fontSize};
      flex: 1;

      p {
        margin: 0;
        padding: 0;
      }

      h3 {
        margin-top: 8px;
      }
    }
  }
`;
UlListWrapper.displayName = 'UlListWrapper';

export default UlListWrapper;
